/* Hemp Hounds — Find Your Formula finder.
   Pick a need -> matched product reveals and the panel re-themes to that
   product's accent. Dependency-free; re-inits on Shopify section load. */
(function () {
  'use strict';

  function initFinder(finder) {
    if (!finder || finder.dataset.hhReady === '1') return;
    finder.dataset.hhReady = '1';

    var wrap = finder.querySelector('.finder-wrap');
    var needs = Array.prototype.slice.call(finder.querySelectorAll('.finder-need'));
    var results = Array.prototype.slice.call(finder.querySelectorAll('.finder-result'));

    needs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-need');
        var acc = btn.getAttribute('data-acc') || 'calm';

        needs.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        results.forEach(function (r) {
          r.classList.toggle('is-active', r.getAttribute('data-result') === key);
        });
        if (wrap) {
          wrap.classList.remove('acc-calm', 'acc-hip', 'acc-skin', 'acc-sage');
          wrap.classList.add('acc-' + acc);
        }
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.hh-finder').forEach(initFinder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
